import $ from 'jquery'

import { tsInitVue } from '../js-utils'
import { initializeAutocompleteField } from '../site-utils'

const initializePeriodsList = (formEl: Element): void => {
  const periodsListEl = formEl.querySelector<HTMLElement>('activity-place-periods-list')
  if (!periodsListEl) return

  void import('../vue-components/ospe/activity-place-periods-list.vue').then(({ default: PeriodsList }) => {
    window.activityPeriodsList = tsInitVue(PeriodsList, periodsListEl)
  })
}

const initializeCourtStaffFields = (formEl: Element): void => {
  const functionSelectEl = formEl.querySelector<HTMLSelectElement>('select[ref="function"]')
  const courtStaffFieldEls = formEl.querySelectorAll<HTMLElement>('[data-auto-hide="court-staff"]')
  if (!functionSelectEl || courtStaffFieldEls.length === 0) return

  const updateCourtStaffFields = (): void => {
    const withCourtStaffFunction = $(functionSelectEl).select2('data')
      .some((item) => item.element?.dataset.courtStaff === 'true')

    courtStaffFieldEls.forEach((fieldEl) => {
      fieldEl.classList.toggle('d-none', !withCourtStaffFunction)
    })
  }

  $(functionSelectEl).on('change.select2', updateCourtStaffFields)
  updateCourtStaffFields()
}

const initializeSpecialisationFields = (formEl: Element): void => {
  const countrySelectEl = formEl.querySelector<HTMLSelectElement>('select[ref="hosting-country"]')
  const hostingNcpSelectEl = formEl.querySelector<HTMLSelectElement>('select[ref="hosting-ospe-ncp"]')
  let hostingNcpAutocompleteUrl: string | null = null

  if (countrySelectEl && hostingNcpSelectEl) {
    initializeAutocompleteField(hostingNcpSelectEl, undefined, undefined, (options) => {
      delete options.minimumInputLength

      if (options.ajax && typeof options.ajax.url === 'function') {
        hostingNcpAutocompleteUrl = options.ajax.url({})
        options.ajax.url = (): string => hostingNcpAutocompleteUrl || ''
      }
      return options
    })
    $(countrySelectEl).on('select2:select', (event) => {
      const ncpUrl = event.params?.data?.element?.dataset?.ncpUrl
      if (ncpUrl) hostingNcpAutocompleteUrl = ncpUrl
    })
  }

  const specialisationSelectEl = formEl.querySelector<HTMLSelectElement>('select[ref="place-specialisation"]')
  if (!specialisationSelectEl) return

  const updateForm = (): void => {
    const withSubSpecialisations = specialisationSelectEl.selectedOptions[0]
      ?.dataset.withSubSpecialisations === 'true'

    formEl.querySelectorAll<HTMLElement>('[data-place-standard-only]').forEach((fieldEl) => {
      fieldEl.classList.toggle('d-none', withSubSpecialisations)
      fieldEl.setAttribute('aria-hidden', String(withSubSpecialisations))
      fieldEl.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
        'input, select, textarea',
      ).forEach((controlEl) => {
        controlEl.disabled = withSubSpecialisations
      })
    })

    if (countrySelectEl && hostingNcpSelectEl) {
      hostingNcpAutocompleteUrl = withSubSpecialisations
        ? hostingNcpSelectEl.dataset.allNcpsUrl || ''
        : countrySelectEl.selectedOptions[0]?.dataset.ncpUrl || hostingNcpSelectEl.dataset.allNcpsUrl || ''
    }
  }

  $(specialisationSelectEl).on('change', updateForm)
  updateForm()
}

export const initializeOspePlaceForm = (
  formEl: HTMLElement | null = document.querySelector<HTMLElement>(
    'body.ospe-activity-places .activity-places-form',
  ),
): void => {
  if (!formEl) return

  initializePeriodsList(formEl)
  initializeSpecialisationFields(formEl)
  initializeCourtStaffFields(formEl)
}
